import { createApp } from 'vue'
import App from './App.vue'
import Oruga from '@oruga-ui/oruga-next'
import '@oruga-ui/oruga-next/dist/oruga.css'

/* Store */
import { store } from '@/store/index.js'

require('@/assets/sass/main.sass')

const app = createApp(App).use(Oruga);


// globals
app.config.globalProperties.categoryIdUnterkonstruktion = 28
app.config.globalProperties.categoryIdMaterial = 29
app.config.globalProperties.categoryIdSchraubenart = 30

app.use(store)
app.mount('#app')